// extracted by mini-css-extract-plugin
module.exports = {"container":"AvatarSection_container__1kpN2","avatar":"AvatarSection_avatar__1eD0O"};